import { useKeycloak } from "@/contexts/KeycloakContext";
import { Spin, Button, Card, Typography } from "antd";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";

const { Title, Text } = Typography;

export default function PrivateRoute() {
  const { t } = useTranslation();
  const { authenticated, loading, login, token } = useKeycloak();
  const hasToken = localStorage.getItem("accessToken");
  
  // Показуємо спінер якщо:
  // 1. Йде завантаження
  // 2. АБО є токен в localStorage, але ще не визначено authenticated (перевірка в процесі)
  if (loading || (hasToken && authenticated === false && !token)) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }
  
  // Якщо не авторизований після завершення перевірки - показуємо форму логіну
  if (!authenticated) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}>
        <Card style={{ width: '100%', maxWidth: 400, boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <Title level={2}>{t('app.name')}</Title>
            <Text type="secondary">{t('auth.loginTitle')}</Text>
          </div>
          <Button
            type="primary"
            size="large"
            block
            onClick={login}
            style={{ height: 48 }}
          >
            {t('auth.login')}
          </Button>
          <div style={{ marginTop: 16, fontSize: 12, color: '#666' }}>
            <Text type="secondary">
              {t('apps.status')}: {loading ? t('common.loading') : authenticated ? t('auth.loginSuccess') : t('auth.loginError')}
            </Text>
            <br />
          </div>
        </Card>
      </div>
    );
  }
  
  return <Outlet />;
}